import Vue from 'vue';
import VueRouter from 'vue-router';

const HomeView = () => import('../views/HomeView/index.vue');
const LoginView = () => import('../views/LoginView/index.vue');
const CallbackView = () => import('../views/CallbackView/index.vue');

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
  },
  {
    path: '/callback',
    name: 'Callback',
    component: CallbackView,
  },
  {
    path: '/',
    name: 'Home',
    component: HomeView,
  },
  {
    path: '/logout',
    name: 'Logout',
    component: LoginView,
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'Login' },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes,
});

router.beforeEach((to, from, next) => {
  const store = router.app.$options.store;
  const { isLoggedIn } = store.state.user;

  if (!isLoggedIn) store.commit('CLEAR_CREDENTIALS');
  if (to.path === '/logout') {
    store.commit('CLEAR_CREDENTIALS');
    return router.push('/login');
  }
  if (to.path === '/login' || to.path === '/callback') return next();
  else if (!isLoggedIn) return next('/login');
  else next();
});

export default router;
